// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1pPUw","controls":"styles_controls__31Xso","select":"styles_select__3dK_5","text":"styles_text__ZOgC1"};